import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'identityProviders',
    collectionActionName: 'IDENTITY_PROVIDERS',
    itemActionName: 'IDENTITY_PROVIDER',
});
